import {
  EoFileUploadConfig,
  IEoFileUploadConfig,
} from '../eo-file-upload/eo-file-upload.model';

export interface IEoFileUploadAdvancedConfig extends IEoFileUploadConfig {
  type?: 'fileUploadAdvanced';
  dragAndDropDescription?: string;
  dragAndDropSummary?: string;
}

export class EoFileUploadAdvancedConfig
  extends EoFileUploadConfig
  implements IEoFileUploadAdvancedConfig
{
  override type?: 'fileUploadAdvanced';
  dragAndDropDescription?: string;
  dragAndDropSummary?: string;

  constructor();
  constructor(obj: IEoFileUploadAdvancedConfig);
  constructor(obj?: IEoFileUploadAdvancedConfig) {
    super(obj as IEoFileUploadAdvancedConfig);
    this.type = 'fileUploadAdvanced';

    this.dragAndDropDescription = obj?.dragAndDropDescription;
    this.dragAndDropSummary = obj?.dragAndDropSummary;
  }
}
